import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {BWCMessaging} from '../BWCMessaging/BWCMessaging';
import {CancelTripModalCategories} from '../CancelTripModalCategories/CancelTripModalCategories';
import {CancelTripModalConfirmation} from '../CancelTripModalConfirmation/CancelTripModalConfirmation';
import {CancelTripModalForm} from '../CancelTripModalForm/CancelTripModalForm';
import {CancelTripModalReasons} from '../CancelTripModalReasons/CancelTripModalReasons';
import translate from '../../../../../../utils/translations';

export default class Cancellation extends Component {
    static propTypes = {
        cancellationReasonsByCategory: PropTypes.arrayOf(PropTypes.shape({})),
        category: PropTypes.shape({}),
        errorMessage: PropTypes.string,
        errorTitle: PropTypes.string,
        hasError: PropTypes.bool,
        message: PropTypes.string,
        onFormChange: PropTypes.func,
        onSelectCategory: PropTypes.func,
        onSelectReason: PropTypes.func,
        reason: PropTypes.shape({}),
        showsBookWithConfidenceMessage: PropTypes.bool,
        step: PropTypes.number,
        translations: PropTypes.shape({}),
        type: PropTypes.string,
    };

    static defaultProps = {
        category: {
            descriptionText: '',
            text: '',
        },
        reason: {
            text: '',
        },
        step: 0,
        translations: {},
    };

    renderModalSteps = () => {
        const {
            cancellationReasonsByCategory,
            category,
            errorMessage,
            errorTitle,
            hasError,
            message,
            onDone,
            onFormChange,
            onSelectCategory,
            onSelectReason,
            reason,
            showsBookWithConfidenceMessage,
            translations,
            type,
        } = this.props;
        let steps = [];

        steps.push(
            <CancelTripModalCategories
                cancellationReasonsByCategory={cancellationReasonsByCategory}
                onSelectCategory={onSelectCategory}
                title={this.props.manageBookingLabel}
                translations={translations}
                disclaimer={
                    type === 'withdrawtrip'
                        ? translate(
                              translations,
                              'trav-dash/trav-home',
                              'messages',
                              'th.inbox.conversation.cancel.modal.text.withdraw.disclaimer'
                          )
                        : translate(
                              translations,
                              'trav-dash/trav-home',
                              'messages',
                              'th.inbox.conversation.cancel.modal.text.disclaimer'
                          )
                }
            />
        );

        steps.push(
            <CancelTripModalReasons
                category={category.category}
                description={category.descriptionText}
                onSelectReason={onSelectReason}
                reasons={category.reasons}
                title={category.text}
            />
        );

        if (showsBookWithConfidenceMessage) {
            steps.push(<BWCMessaging translations={translations} />);
        }

        steps.push(
            <CancelTripModalForm
                description={reason.text}
                onChange={onFormChange}
                reason={reason}
                title={category.text}
                translations={translations}
                value={message}
            />
        );

        steps.push(
            <CancelTripModalConfirmation
                hasError={hasError}
                onClose={onDone}
                text={errorMessage}
                title={errorTitle}
                translations={translations}
            />
        );

        return steps;
    };

    render() {
        const {
            props: {step},
        } = this;
        return this.renderModalSteps()[step];
    }
}
